<style lang="scss" scoped>
@import '@/css/color.scss';
.SearchBar {
    width: 268px;
    height: 37px;
    border-radius: 4px;
    margin-right: 10px;
    display: flex;
    .border {
        height: 100%;
        border: 1px solid #DEE4EC;
        border-radius: 4px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        flex-grow: 1;
        border-right-width: 0px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        margin: 0px;
        .title {
            min-width: 54px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #646b74;
            padding-left: 14px;
            padding-right: 11px;
            position: relative;
            height: 100%;
            cursor: default;
            &:hover {
                .dropList {
                    display: block;
                }
            }
            >img {
                padding-left: 5px;
            }
            .dropList {
                display: none;
                position: absolute;
                background-color: #fff;
                width: 120px;
                box-shadow: 0 0 4px 0 rgba(0,0,0,0.07);
                border-radius: 4px;
                top: 34px;
                left: 0px;
                z-index: 2;
                >p {
                    height: 38px;
                    line-height: 38px;
                    font-size: 14px;
                    color: #626262;
                    letter-spacing: 0;
                    padding-left: 20px;
                    cursor: pointer;
                    &:hover {
                        background: #F2F6FB;
                    }
                }
            }
        }
        .line {
            height: 17px;
            background-color: #d8e0e8;
            width: 1px;
        }
        >input {
            flex-grow: 1;
            width: 0px;
            height: 100%;
            border: none;
            outline: none;
            padding-left: 8px;
            font-size: 14px;
        }
    }
    .Btn {
        flex-shrink: 0;
        width: 50px;
        height: 100%;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
}
</style>

<template>
    <div class="SearchBar" >
        <div class="border" >
            <div class="title">
                <p><slot></slot></p>
                <img v-if="options && options.length > 1" src="@/assets/search_bar_down.svg" alt="">
                <div  v-if="showDropList && options && options.length > 1" class="dropList">
                    <p v-for="o in options" :key="o" @click="optionClick(o)" >{{o}}</p>
                </div>
            </div>
            <div class="line" ></div>
            <input :value="value" @input="input" @keyup.enter="search" autocomplete="false" type="text" >
        </div>
        <Btn @click="search" ><img src="@/assets/search_bar_search.svg"></Btn>
    </div>
</template>

<script>
export default {
    props: [
        'value',
        'options'
    ],
    data() {
        return {
            showDropList: true
        }
    },
    computed: {

    },
    methods: {
        search: function () {
            this.$emit('search')
        },
        input: function (e) {
            this.$emit('input',e.target.value)
        },
        optionClick: function (option) {
            this.$emit('option-changed', option)
            this.showDropList = false
            setTimeout(() => {
                this.showDropList = true
            }, 0);
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/common/SearchBar.vue